// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DdpiModal_modalOverlay__sngEL {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.DdpiModal_modalContent__Z1YjV {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: 'CircularXXWeb-Medium', sans-serif;
}

.DdpiModal_closeButton__pboHN {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}

.DdpiModal_closeButton__pboHN:hover {
  color: #333;
}

.DdpiModal_title__HWoIG {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
  font-size: 1.2rem;
  font-weight: bold;
}

.DdpiModal_allOptionsContainer__PnPI2 {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.DdpiModal_allOptionsLabel__jnou8 {
  display: flex;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

.DdpiModal_checkbox__345vO {
  margin-right: 10px;
  width: 18px;
  height: 18px;
  accent-color: #007bff;
  cursor: pointer;
}

.DdpiModal_optionsList__765S1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.DdpiModal_optionItem__uqWEl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.DdpiModal_optionLabel__KSbia {
  font-size: 0.95rem;
  color: #444;
}

.DdpiModal_radioGroup__xm3qQ {
  display: flex;
  gap: 15px;
}

.DdpiModal_radioLabel__WY7JV {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.DdpiModal_radioInput__godmw {
  margin-right: 5px;
  accent-color: #007bff;
  cursor: pointer;
}

.DdpiModal_saveButtonContainer__I6fgm {
  margin-top: 25px;
  text-align: center;
}

.DdpiModal_saveButton__L4\\+CS {
  padding: 10px 30px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s;
}

.DdpiModal_saveButton__L4\\+CS:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/DdpiModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-family: 'CircularXXWeb-Medium', sans-serif;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  transition: color 0.2s;\n}\n\n.closeButton:hover {\n  color: #333;\n}\n\n.title {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #333;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.allOptionsContainer {\n  margin-bottom: 15px;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.allOptionsLabel {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.checkbox {\n  margin-right: 10px;\n  width: 18px;\n  height: 18px;\n  accent-color: #007bff;\n  cursor: pointer;\n}\n\n.optionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.optionItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.optionLabel {\n  font-size: 0.95rem;\n  color: #444;\n}\n\n.radioGroup {\n  display: flex;\n  gap: 15px;\n}\n\n.radioLabel {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.radioInput {\n  margin-right: 5px;\n  accent-color: #007bff;\n  cursor: pointer;\n}\n\n.saveButtonContainer {\n  margin-top: 25px;\n  text-align: center;\n}\n\n.saveButton {\n  padding: 10px 30px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.saveButton:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DdpiModal_modalOverlay__sngEL`,
	"modalContent": `DdpiModal_modalContent__Z1YjV`,
	"closeButton": `DdpiModal_closeButton__pboHN`,
	"title": `DdpiModal_title__HWoIG`,
	"allOptionsContainer": `DdpiModal_allOptionsContainer__PnPI2`,
	"allOptionsLabel": `DdpiModal_allOptionsLabel__jnou8`,
	"checkbox": `DdpiModal_checkbox__345vO`,
	"optionsList": `DdpiModal_optionsList__765S1`,
	"optionItem": `DdpiModal_optionItem__uqWEl`,
	"optionLabel": `DdpiModal_optionLabel__KSbia`,
	"radioGroup": `DdpiModal_radioGroup__xm3qQ`,
	"radioLabel": `DdpiModal_radioLabel__WY7JV`,
	"radioInput": `DdpiModal_radioInput__godmw`,
	"saveButtonContainer": `DdpiModal_saveButtonContainer__I6fgm`,
	"saveButton": `DdpiModal_saveButton__L4+CS`
};
export default ___CSS_LOADER_EXPORT___;
